import cx from 'clsx';
import * as React from 'react';

import styles from './LayersWrapper.module.scss';

interface LayersWrapperProps {
  rounded?: 'all' | 'top';
  children?: React.ReactNode;
  containerStyles?: string;
  className?: string;
  borderRadius?: number;
}

const LayersWrapper = ({
  children,
  rounded,
  containerStyles,
  className,
  borderRadius = 6,
}: LayersWrapperProps) => {
  let borderClass;

  if (rounded === 'top') borderClass = styles.roundedTop;
  if (rounded === 'all') borderClass = styles.rounded;

  const containerStyle = containerStyles ? containerStyles : styles.container;

  return (
    <div
      className={cx(containerStyle, borderClass, styles[`${className}`])}
      style={
        rounded === 'top'
          ? {
              borderTopLeftRadius: `${borderRadius}px`,
              borderTopRightRadius: `${borderRadius}px`,
            }
          : { borderRadius: `${borderRadius}px` }
      }
      data-testid="layers-wrapper-element"
    >
      {children}
    </div>
  );
};

export default LayersWrapper;
